import { createContext, useState, useContext, useEffect } from 'react'
import { useAuth } from './AuthProvider'
import { useConfig } from './ConfigProvider';
import {
    GetCustomerOfferHeaders, GetRequestOfferHeaders, GetRetailerOfferHeaders, GetInvestors, CreateRequestOffer, GetInvestorsTypes, CreateRetailerOffer,
    CreateCustomerOffer, GetRequestOfferItems, GetRetailerOfferItems, GetCustomerOfferItems, GetBasketForAcceptedOffer, GetSavedOffer, CreateUpdateSavedOffer, DeleteSavedOffer,
    GetCurrentSavedOfferId, AddUpdateProductToSavedOffer, CreateUpdateSavedOfferInvestObject, GetSavedOfferInvestObject, DeleteRetailerOffer, GetOfferFiltersData, GetNumberOfUnreadCustomerOffer,
    GetAvailabilityForAkceptedOffer, ChangeOfferStatus, GetCustomerOffer
} from '../Services/OfferService';
import { toast } from 'react-toastify';
import axios from 'axios';
export const OfferContext = createContext()

export const useOffers = () => {
    return useContext(OfferContext);
};

export const OffersProvider = ({ children }) => {
    const { authState, logout } = useAuth()
    const { api } = useConfig()

    const [customerOffers, setCustomerOffers] = useState([])
    const [isLoadingCustomerOffers, setIsLoadingCustomerOffers] = useState(false)
    const [customerOffersHasMore, setCustomerOffersHasMore] = useState(false)
    const [customerOffersPage, setCustomerOffersPage] = useState(0)

    const [retailerOffers, setRetailerOffers] = useState([])
    const [isLoadingRetailerOffers, setIsLoadingRetailerOffers] = useState(false)
    const [retailerOffersHasMore, setRetailerOffersHasMore] = useState(false)
    const [retailerOffersPage, setRetailerOffersPage] = useState(0)

    const [requestOffers, setRequestOffers] = useState([])
    const [isLoadingRequestOffers, setIsLoadingRequestOffers] = useState(false)
    const [requestOffersHasMore, setRequestOffersHasMore] = useState(false)
    const [requestOffersPage, setRequestOffersPage] = useState(0)

    const [investors, setInvestors] = useState([])
    const [investorsTypes, setInvestorsTypes] = useState([])

    //DK : To jest tworzenie oferty
    const [savedOfferId, setSavedOfferId] = useState(-1) //Id savedOffer do której dodajemy pozycje, na tej fladze przełączamy tryb pracy    
    const [selectedSavedOffer, setSelectedSavedOffer] = useState(null) //Zapisana oferta na której pracuje pracownik, pobierana po zmianie savedOfferId

    //DK : To jest realizacja zamówienia z oferty
    const [orderItemsFromOffer, setOrderItemsFromOffer] = useState([])

    const [numberOfUnreadCustomerOffer, setNumberOfUnreadCustomerOffer] = useState(0)
    const [editOfferRequestOfferNo, setEditOfferRequestOfferNo] = useState(null) //Numer edytowanej oferty zapisujemy gdy przechodzimy do dodawania kolejnych pozycji w ofercie  

    useEffect(() => {
        if (savedOfferId != -1) {
            GetSavedOffer(api, authState.custId, authState.whId, authState.siteId, 0, savedOfferId, null).then(res => {
                setSelectedSavedOffer(res.data)
            }).catch(e => {
                console.log(e)
            })
        }
        else {
            setSelectedSavedOffer(null)
        }
    }, [savedOfferId])

    useEffect(() => {
        handleGetInvestors()
        handleGetInvestorsTypes()
    }, [api])

    const handleGetInvestors = () => {
        GetInvestors(api, authState.custId).then(res => {
            setInvestors(res.data)
        })
            .catch(e => {
                console.log(e)
                setInvestors([])
            })
    }

    const handleGetInvestorsTypes = () => {
        GetInvestorsTypes(api).then(res => {
            setInvestorsTypes(res.data)
        })
            .catch(e => {
                console.log(e)
                setInvestorsTypes([])
            })
    }

    const handleGetCustomerOffers = (offersFilter, cancelToken) => {
        if (customerOffersPage === 0) {
            setCustomerOffers([])
        }
        setIsLoadingCustomerOffers(true)
        GetCustomerOfferHeaders(api, offersFilter, cancelToken, customerOffersPage).then(res => {
            setCustomerOffers(prev => {
                const merged = [...prev, ...res.data].filter(x => x.offerNo)
                const unique = [...new Map(merged.map(item => [item.offerNo, item])).values()]
                return unique
            })
            setCustomerOffersHasMore(res.data.length > 0)
            setIsLoadingCustomerOffers(false)
        }).catch(e => {
            if (axios.isCancel(e)) {
                return
            }
            if (e.response.status === 403) {
                if (e.response.data.includes('Brak uprawnień')) {
                    toast.error('Brak uprawnień!')
                }
                else { //konto nieaktywne, automatyczne wylogowanie
                    logout(false, false)
                }
            }
            console.log(e)
            setIsLoadingCustomerOffers(false)
            setCustomerOffers([])

        })
    }

    const handleGetRetailerOffers = (offersFilter, cancelToken) => {
        if (retailerOffersPage === 0) {
            setRetailerOffers([])
        }
        setIsLoadingRetailerOffers(true)
        GetRetailerOfferHeaders(api, offersFilter, cancelToken, retailerOffersPage).then(res => {
            setRetailerOffers(prev => {
                const merged = [...prev, ...res.data].filter(x => x.offerNo)
                const unique = [...new Map(merged.map(item => [item.offerNo, item])).values()]
                return unique
            })
            setRetailerOffersHasMore(res.data.length > 0)
            setIsLoadingRetailerOffers(false)
        }).catch(e => {
            if (axios.isCancel(e)) {
                return
            }
            if (e.response.status === 403) {
                if (e.response.data.includes('Brak uprawnień')) {
                    toast.error('Brak uprawnień!')
                }
                else { //konto nieaktywne, automatyczne wylogowanie
                    logout(false, false)
                }
            }
            console.log(e)
            setIsLoadingRetailerOffers(false)
            setRetailerOffers([])
        })
    }

    const handleGetRequestOffers = (offersFilter, cancelToken) => {
        if (requestOffersPage === 0) {
            setRequestOffers([])
        }
        setIsLoadingRequestOffers(true)
        GetRequestOfferHeaders(api, offersFilter, cancelToken, requestOffersPage).then(res => {
            setRequestOffers(prev => {
                const merged = [...prev, ...res.data].filter(x => x.offerNo)
                const unique = [...new Map(merged.map(item => [item.offerNo, item])).values()]
                return unique
            })
            setRequestOffersHasMore(res.data.length > 0)
            setIsLoadingRequestOffers(false)
        }).catch(e => {
            if (axios.isCancel(e)) {
                return
            }
            if (e.response.status === 403) {
                if (e.response.data.includes('Brak uprawnień')) {
                    toast.error('Brak uprawnień!')
                }
                else { //konto nieaktywne, automatyczne wylogowanie
                    logout(false, false)
                }
            }
            console.log(e)
            setIsLoadingRequestOffers(false)
            setRequestOffers([])
        })
    }

    const handleRequestForOffer = async (offerRequest, items, newInvestor) => {
        try {
            const warehouse = getSiteAndWhIdForOffer()
            const res = await CreateRequestOffer(api, offerRequest, items, warehouse.siteId, authState.custId, newInvestor, warehouse.whId)
            return true
        } catch (e) {
            if (e.response.status === 403) {
                if (e.response.data.includes('Brak uprawnień')) {
                    toast.error('Brak uprawnień!')
                }
                else { //konto nieaktywne, automatyczne wylogowanie
                    logout(false, false)
                }
            }
            console.log(e)
            return false
        }

    }

    const handleSendRetailerOffer = async (offerRequest, items, newInvestor) => {
        try {
            const warehouse = getSiteAndWhIdForOffer()
            const res = await CreateRetailerOffer(api, offerRequest, items, warehouse.siteId, authState.custId, newInvestor, warehouse.whId)
            return true
        } catch (e) {
            if (e.response.status === 403) {
                if (e.response.data.includes('Brak uprawnień')) {
                    toast.error('Brak uprawnień!')
                }
                else { //konto nieaktywne, automatyczne wylogowanie
                    logout(false, false)
                }
            }
            console.log(e)
            return false
        }
    }

    const handleCreateCustomerOffer = async (offerRequest, items, newInvestor, isOfferAccepted, requestOfferNo) => {
        try {
            const warehouse = getSiteAndWhIdForOffer()
            const res = await CreateCustomerOffer(api, offerRequest, items, warehouse.siteId, authState.custId, newInvestor, isOfferAccepted, warehouse.whId, requestOfferNo)
            return true
        } catch (e) {
            if (e.response.status === 403) {
                if (e.response.data.includes('Brak uprawnień')) {
                    toast.error('Brak uprawnień!')
                }
                else { //konto nieaktywne, automatyczne wylogowanie
                    logout(false, false)
                }
            }
            if (e.response.status === 409) {
                toast.warning(`Nie udało się edytowac oferty: ${e.response.data}`)
                return -1
            }
            console.log(e)
            return false
        }
    }

    /**
     * DK : Oferty zawsze trafiaja do oddziału i magazynu przypisanego do kontrahenta
     * @returns 
     */
    const getSiteAndWhIdForOffer = () => {
        const siteId = authState.selectedCustomerData ? authState.selectedCustomerData.siteId : authState.initialSiteId
        const whId = authState.selectedCustomerData ? authState.selectedCustomerData.whId : authState.initialWhId
        return { siteId, whId }
    }

    const handleGetRequestOfferItems = async (offerNo, offerSiteId) => {
        try {
            const result = await GetRequestOfferItems(api, authState.custId, offerNo, offerSiteId)
            return result.data
        } catch (e) {
            if (e.response.status === 403) {
                if (e.response.data.includes('Brak uprawnień')) {
                    toast.error('Brak uprawnień!')
                }
                else { //konto nieaktywne, automatyczne wylogowanie
                    logout(false, false)
                }
            }
            console.log(e)
            return []
        }
    }

    const handleGetRetailerOfferItems = async (offerNo, offerSiteId) => {
        try {
            const result = await GetRetailerOfferItems(api, authState.custId, offerNo, offerSiteId)
            return result.data
        } catch (e) {
            if (e.response.status === 403) {
                if (e.response.data.includes('Brak uprawnień')) {
                    toast.error('Brak uprawnień!')
                }
                else { //konto nieaktywne, automatyczne wylogowanie
                    logout(false, false)
                }
            }
            console.log(e)
            return []
        }
    }

    const handleGetCustomerOfferItems = async (offerNo, offerSiteId) => {
        try {
            const result = await GetCustomerOfferItems(api, authState.custId, offerNo, offerSiteId)
            return result.data
        } catch (e) {
            if (e.response.status === 403) {
                if (e.response.data.includes('Brak uprawnień')) {
                    toast.error('Brak uprawnień!')
                }
                else { //konto nieaktywne, automatyczne wylogowanie
                    logout(false, false)
                }
            }
            console.log(e)
            return []
        }
    }

    const handleGetBasketForAcceptedOffer = async (custId, offerNo, offerSiteId) => {
        try {
            const res = await GetBasketForAcceptedOffer(api, custId, offerNo, offerSiteId, authState.whId)
            return res.data
        } catch (e) {
            console.log(e)
            return null
        }
    }

    const handleGetSavedOffer = async (mode, offerId = null) => {
        try {
            const res = await GetSavedOffer(api, authState.custId, authState.whId, authState.siteId, mode, offerId)
            return res.data
        } catch (e) {
            console.log(e)
            return null
        }
    }

    const handleCreateUpdateSavedOffer = async (mode, offerRequest, products, offerExpiredDate = null) => {
        try {
            let isPh = authState.user && authState.user.isOperator ? true : false
            const res = await CreateUpdateSavedOffer(api, mode, offerRequest, products, isPh, offerExpiredDate)
            return res.data
        } catch (e) {
            console.log(e)
            return -1
        }
    }

    const handleDeleteSavedOffer = async (mode) => {
        try {
            await DeleteSavedOffer(api, mode)
            return true
        } catch (error) {
            console.log(error)
            return false
        }
    }

    const handleGetCurrentSavedOfferId = async (mode) => {
        try {
            const res = await GetCurrentSavedOfferId(api, mode)
            return res.data
        } catch (e) {
            console.log(e)
            return -1
        }
    }

    const handleAddUpdateProductToSavedOffer = async (product, quantity) => {
        try {
            let res = await AddUpdateProductToSavedOffer(api, product, quantity, savedOfferId)
            return res.data
        } catch (e) {
            console.log(e)
            return false
        }
    }

    const getProductQuantityInSavedOffer = (product) => {
        if (!authState.user || !selectedSavedOffer || selectedSavedOffer.basketItems === null || selectedSavedOffer.basketItems === undefined) {
            return 0
        }
        var result = selectedSavedOffer.basketItems.find(e => e.product.index === product.index)
        if (result) {
            return result.qty
        }
        return 0
    }

    const getProductQuantityInRealizedOffer = (product) => {
        if (!authState.user || !orderItemsFromOffer || orderItemsFromOffer.length === 0) {
            return 0
        }
        var result = orderItemsFromOffer.find(e => e.product.index === product.index)
        if (result) {
            return result.qty
        }
        return 0
    }

    const handleCreateUpdateSavedOfferInvestObject = async (mode, investorObject, addNew) => {
        try {
            let tmpInvestorToAdd = investorObject
            if (addNew) { //tutaj jest jakiś błd w danych dlatego odwracam właściwości
                tmpInvestorToAdd.objectTypeId = tmpInvestorToAdd.objectId
                tmpInvestorToAdd.objectId = -1
            }
            let res = await CreateUpdateSavedOfferInvestObject(api, mode, tmpInvestorToAdd)
            return res.data
        } catch (e) {
            console.log(e)
            return false
        }
    }

    const handleGetSavedOfferInvestObject = async (mode) => {
        try {
            const res = await GetSavedOfferInvestObject(api, mode)
            return res.data
        } catch (e) {
            console.log(e)
            return null
        }
    }

    const handleDeleteRetailerOffer = async (offerNo, offerSiteId) => {
        try {
            const res = await DeleteRetailerOffer(api, authState.custId, offerNo, offerSiteId)
            return res.data
        } catch (error) {
            console.log(error)
            return false
        }
    }

    const handleGetOfferFiltersData = async (offerCurrentView, offersFilter, cancelToken) => {
        try {
            const res = await GetOfferFiltersData(api, offerCurrentView, offersFilter, cancelToken)
            return res.data
        } catch (error) {
            if (axios.isCancel(error)) {
                return
            }
            console.log(error)
            return []
        }
    }

    const handleGetNumberOfUnreadCustomerOffer = async (cancelToken) => {
        try {
            if (!authState.user || !authState.custId) {
                return 0
            }
            const res = await GetNumberOfUnreadCustomerOffer(api, authState.custId, cancelToken)
            setNumberOfUnreadCustomerOffer(res.data)
        } catch (error) {
            console.log(error)
            setNumberOfUnreadCustomerOffer(0)
        }
    }

    const handleGetAvailabilityForAkceptedOffer = async () => {
        try {
            if (orderItemsFromOffer && orderItemsFromOffer.length > 0) {
                let res = await GetAvailabilityForAkceptedOffer(api, orderItemsFromOffer, authState.whId)
                setOrderItemsFromOffer(res.data)
            }
            return []
        } catch (error) {
            console.log(error)
            return []
        }
    }

    const handleChangeOfferStatus = async (offerNo, offerSiteId, cancelToken) => {
        if (authState && authState.user && authState.user.isOperator) { //Tylko klient aktualizuje status po przeczytaniu oferty
            return true
        }
        try {
            await ChangeOfferStatus(api, authState.custId, offerNo, offerSiteId, cancelToken)
            return true
        } catch (error) {
            if (!axios.isCancel(error)) {
                console.log(error)
                return false
            }
        }
    }

    const getCustomerOffer = async (offerNo, offerSiteId) => {
        try {
            const res = await GetCustomerOffer(api, offerNo, authState.custId, offerSiteId)
            return res.data
        } catch (e) {
            console.log(e)
            return null
        }
    }

    return (
        <OfferContext.Provider value={{
            requestOffers,
            retailerOffers,
            customerOffers,
            isLoadingCustomerOffers,
            isLoadingRequestOffers,
            isLoadingRetailerOffers,
            investors,
            investorsTypes,
            savedOfferId,
            selectedSavedOffer,
            retailerOffersHasMore,
            retailerOffersPage,
            requestOffersHasMore,
            requestOffersPage,
            customerOffersHasMore,
            customerOffersPage,
            numberOfUnreadCustomerOffer,
            editOfferRequestOfferNo,
            orderItemsFromOffer,
            handleGetRequestOfferItems,
            handleGetRetailerOfferItems,
            handleGetCustomerOfferItems,
            handleGetBasketForAcceptedOffer,
            handleGetSavedOffer,
            handleCreateUpdateSavedOffer,
            handleDeleteSavedOffer,
            setSavedOfferId,
            handleGetCurrentSavedOfferId,
            handleAddUpdateProductToSavedOffer,
            handleGetCustomerOffers,
            handleGetRequestOffers,
            handleGetRetailerOffers,
            handleRequestForOffer,
            handleGetInvestors,
            handleSendRetailerOffer,
            handleCreateCustomerOffer,
            getProductQuantityInSavedOffer,
            setSelectedSavedOffer,
            handleCreateUpdateSavedOfferInvestObject,
            handleGetSavedOfferInvestObject,
            handleDeleteRetailerOffer,
            setRetailerOffersPage,
            setRequestOffersPage,
            setCustomerOffersPage,
            handleGetOfferFiltersData,
            handleGetNumberOfUnreadCustomerOffer,
            setEditOfferRequestOfferNo,
            setOrderItemsFromOffer,
            getProductQuantityInRealizedOffer,
            handleGetAvailabilityForAkceptedOffer,
            handleChangeOfferStatus,
            getCustomerOffer,
        }}>
            {children}
        </OfferContext.Provider>
    )
}